'use client';

import React, { useEffect, useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import AppLogo from '@/components/ui/AppLogo';
import { getPrivateMode } from '@/lib/privateModeStore';

export default function PrivateModeGate({ children }: { children: React.ReactNode }) {
  const [isPrivate, setIsPrivate] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    getPrivateMode().then((val) => {
      setIsPrivate(val);
      setChecked(true);
    });

    const handler = (e: Event) => {
      const detail = (e as CustomEvent<{ enabled: boolean }>).detail;
      setIsPrivate(detail.enabled);
    };
    window.addEventListener('privateModeChange', handler);
    return () => window.removeEventListener('privateModeChange', handler);
  }, []);

  if (!checked) return null;

  if (isPrivate) {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
        <div className="flex flex-col items-center gap-6 max-w-sm text-center">
          <AppLogo size={56} />
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 border border-primary/20">
            <Icon name="LockClosedIcon" size={28} className="text-primary" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-foreground mb-2">Site is Private</h1>
            <p className="text-muted-foreground text-sm leading-relaxed">
              AwardFlix is currently in private mode and not available to the public. Please check back later.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
